export default __webpack_public_path__ + "static/item_10-e836230d6deb99b969c28de1a8dbe12f.jpg";